import React, { createContext, useContext, useState, useEffect } from 'react';

// Available themes
const themes = {
  light: {
    name: 'light',
    primaryColor: '#0d6efd',
    backgroundColor: '#ffffff',
    textColor: '#212529',
    secondaryColor: '#6c757d',
    accentColor: '#ffc107'
  },
  blue: {
    name: 'blue',
    primaryColor: '#0d6efd',
    backgroundColor: '#f8f9fa',
    textColor: '#212529',
    secondaryColor: '#6c757d',
    accentColor: '#0dcaf0'
  },
  green: {
    name: 'green',
    primaryColor: '#198754',
    backgroundColor: '#f8f9fa',
    textColor: '#212529',
    secondaryColor: '#6c757d',
    accentColor: '#20c997'
  }
};

const ThemeContext = createContext();

export const useTheme = () => useContext(ThemeContext);

export const ThemeProvider = ({ children }) => {
  const [currentTheme, setCurrentTheme] = useState(() => {
    const savedTheme = localStorage.getItem('theme');
    // Si le thème sauvegardé est 'dark' ou n'existe pas, utiliser 'light'
    if (savedTheme === 'dark' || !themes[savedTheme]) {
      return 'light';
    }
    return savedTheme;
  });

  const theme = themes[currentTheme];

  useEffect(() => {
    localStorage.setItem('theme', currentTheme);
    
    // Apply theme to document (toujours 'light' maintenant)
    document.documentElement.setAttribute('data-bs-theme', 'light');
    
    // Apply custom CSS variables
    document.documentElement.style.setProperty('--primary-color', theme.primaryColor);
    document.documentElement.style.setProperty('--background-color', theme.backgroundColor);
    document.documentElement.style.setProperty('--text-color', theme.textColor);
    document.documentElement.style.setProperty('--secondary-color', theme.secondaryColor);
    document.documentElement.style.setProperty('--accent-color', theme.accentColor);
  }, [currentTheme, theme]);

  const changeTheme = (themeName) => {
    if (themes[themeName]) {
      setCurrentTheme(themeName);
    }
  };

  const getAvailableThemes = () => {
    return Object.keys(themes).map(key => ({
      name: key,
      ...themes[key]
    }));
  };

  const value = {
    currentTheme,
    theme,
    changeTheme,
    getAvailableThemes
  };

  return (
    <ThemeContext.Provider value={value}>
      {children}
    </ThemeContext.Provider>
  );
};

